export default {
    FULL_REPORT: 'FULL_REPORT',
    TOTALS_ONLY: 'TOTALS_ONLY'
};
